import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import {MDForm} from '../../metadata/MDForm';
import {ProductInfoContext} from '../../data/ApplicationDataSource';
import {DeclaredComponent} from '../../DynamicComponent';
import {ComponentType} from '../../../utils/componentType';
import {errorSink} from '../../ErrorSink';
import {ModelContext} from "../../metadata/ModelSource";

export function LineForm({ children, content, lineCd }) {
  const applicationModel = useContext(ModelContext);
  const {productSetup} = useContext(ProductInfoContext);

  let linePrefix = `lines{lineCd:${lineCd}}`;

  const lineProductSetupContext = getLineProductSetupContext(productSetup, applicationModel, lineCd);


  if (!lineProductSetupContext) {
    throw 'no product setup found for line ' + lineCd;
}

  return <MDForm prefix={linePrefix} productSetupContext={lineProductSetupContext}
                 model={applicationModel} presentationMetadata={content}>

    {children}

  </MDForm>;

}

export function getLineProductSetupContext(productSetup, applicationModel, lineCd) {
  const subTypeProductSetupContext = getSubTypeProductSetupContext(productSetup, applicationModel);
  if (!subTypeProductSetupContext || !subTypeProductSetupContext.productLine) {
    return null;
  }
  return subTypeProductSetupContext.productLine.find(l => l.lineCd === lineCd);
}

export function getSubTypeProductSetupContext(productSetup, applicationModel) {
  if (!productSetup.productSubTypes || !productSetup.productSubTypes.productSubType) {
    return null;
  }
  const subTypeCd = applicationModel.getValue('basicPolicy.SubType');
  return subTypeCd ? productSetup.productSubTypes.productSubType.find(s => s.subTypeCd === subTypeCd) : productSetup.productSubTypes.productSubType[0];
}

LineForm.propTypes = {
  content: ComponentType,
  lineCd: PropTypes.string.isRequired
};